import { ThemeDefinition } from 'vuetify';

export const civics: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#CF9D58',
    'on-subject-original': '#FFFFFF',
    subject: '#9B6A27',
    'on-subject': '#FFFFFF',
    primary: '#735021',
    'on-primary': '#FFFFFF',
    secondary: '#615648',
    'on-secondary': '#FFFFFF',
    'primary-container': '#EEDCC4',
    'on-primary-container': '#30210E',
    'secondary-container': '#DEDAD3',
    'on-secondary-container': '#231F1A',
    surface: '#FCFAF7',
    'on-surface': '#201F1D',
    'on-surface-medium': '#504D49',
    'on-surface-low': '#9E9A94',
    outline: '#868179',
    'outline-variant': '#CFCCC9',
    'inverse-surface': '#423524',
    'inverse-on-surface': '#F6F3EE',
    'inverse-primary': '#E8D1B0',
    'surface-dim': '#EBD9C2',
    'surface-bright': '#FEFDFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF6F0',
    'surface-container': '#F7F1E8',
    'surface-container-high': '#F2E8D9',
    'surface-container-highest': '#F0E3D1',
  },
};

export const civicsDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#CF9D58',
    'on-subject-original': '#FDFAF7',
    subject: '#D7AE74',
    'on-subject': '#30210E',
    primary: '#E6CCA8',
    'on-primary': '#30210E',
    secondary: '#D6D0C7',
    'on-secondary': '#231F1A',
    'primary-container': '#6B4B1F',
    'on-primary-container': '#F9F3EB',
    'secondary-container': '#584E41',
    'on-secondary-container': '#F4F2F0',
    surface: '#181510',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFCDC9',
    'on-surface-low': '#868179',
    outline: '#9E9A94',
    'outline-variant': '#6B6761',
    'inverse-surface': '#EDE7DE',
    'inverse-on-surface': '#282015',
    'inverse-primary': '#4F3817',
    'surface-dim': '#15120E',
    'surface-bright': '#463D2F',
    'surface-container-lowest': '#12100C',
    'surface-container-low': '#1F1A14',
    'surface-container': '#28221B',
    'surface-container-high': '#342D23',
    'surface-container-highest': '#433A2D',
  },
};
